import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { GrIcon } from "../../icons";
import { palette } from "../../../theme/palette";
import { typography } from "../../../theme/typography";
import styled from "@emotion/styled";
import classNames from "classnames";
// eslint-disable-next-line no-empty-pattern
const StyledEmptyWrapper = styled("div")(({}) => {
    return {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
    };
});
const StyledIconWrapper = styled("div")(({ type }) => {
    return {
        marginBottom: type === "simple" ? "12px" : "24px",
        padding: 0,
    };
});
const StyledTitleTypography = styled("p")(({ type }) => {
    return {
        margin: "0 0 6px 0",
        padding: 0,
        color: palette[type === "simple" ? "grey060" : "grey080"],
        whiteSpace: "pre",
        ...typography["Content.Subtitle02"],
    };
});
const StyledDescriptionTypography = styled("p")(({ type }) => {
    return {
        margin: 0,
        padding: 0,
        color: palette[type === "simple" ? "grey060" : "grey070"],
        whiteSpace: "pre",
        ...typography["Content.Body04"],
    };
});
export function GrEmpty(props) {
    const { type, title, description, className, color } = props;
    const iconMap = {
        noFile: "visual-no-file",
        noData: "visual-no-data",
        dragAndDrop: "visual-drag-and-drop",
        notFound: "visual-404",
    };
    return (_jsxs(StyledEmptyWrapper, { className: classNames("GrEmpty", className), children: [!!type && (_jsx(StyledIconWrapper, { type: type, children: type !== "simple" ? (_jsx(GrIcon, { type: iconMap[type], size: 180 })) : (_jsx(GrIcon, { type: "visual-no-content", size: 36, color: color || "grey030" })) })), title && _jsx(StyledTitleTypography, { type: type, children: title }), description && _jsx(StyledDescriptionTypography, { type: type, children: description })] }));
}
//# sourceMappingURL=GrEmpty.js.map